import { render, staticRenderFns } from "./data-model-list.vue?vue&type=template&id=784f55de"
import script from "./data-model-list.vue?vue&type=script&lang=js"
export * from "./data-model-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports